import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { userLoggedOut, userLoggedIn } from '../redux/slices/authSlice';

/*
 * Initialize auth state on app load
 */
function useAuthInitialization() {
  const dispatch = useDispatch();

  useEffect(() => {
    const Auth = require('j-toker/src/j-toker');

    Auth.validateToken()
      .then((userData) => {
        dispatch(userLoggedIn(userData));
      })
      .catch(() => {
        dispatch(userLoggedOut());
      });
  }, [dispatch]);
}

export default useAuthInitialization;
